export const LOCATION_TABLE = "locations"
export const LOCATION_TABLE_SCHEMA = "id, companyId, code, name, syncId"
